<template>
  <div class="rule-item">
    <div class="rule-header-wrapper">
      <div class="rule-header">
        <span class="label">还车电量要求</span>
        <i class="el-icon-delete delete-btn" @click="emit('remove')"></i>
      </div>
    </div>
    <RuleTip :tip="tip" />
    <div class="rule-body">
      <div class="flex-row">
        <span class="label-text">还车时剩余电量 &lt; </span>
        <el-form-item
          :prop="`${propPrefix}.returnBatteryRemaining`"
          class="flex-input"
          style="margin: 0 10px; margin-bottom: 0;"
          :rules="getRules(1000, 1)"
        >
          <el-input
            :value="modelValue.returnBatteryRemaining"
            @input="updateField('returnBatteryRemaining', $event)"
            placeholder="请输入"
            size="small"
            v-integer-number
          >
            <el-select :value="modelValue.returnBatteryRemainingUnit" @input="updateField('returnBatteryRemainingUnit', $event)" slot="append" style="width: 70px;">
              <el-option label="公里" value="km"></el-option>
              <el-option label="%" value="%"></el-option>
            </el-select>
          </el-input>
        </el-form-item>
        <span class="label-text">需支付充电服务费</span>
        <el-form-item :prop="`${propPrefix}.batteryRechargeFee`" class="flex-input" style="margin: 0 10px; margin-bottom: 0;" :rules="getRules(1000)">
          <el-input
            :value="modelValue.batteryRechargeFee"
            placeholder="请输入"
            size="small"
            v-number:float
            @input="updateField('batteryRechargeFee', $event)"
          >
          <template slot="append">元</template>
        </el-input>
        </el-form-item>
      </div>
    </div>
  </div>
</template>

<script setup>
import { getRules } from './utils'
import RuleTip from './RuleTip.vue'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  propPrefix: {
    type: String,
    required: true,
  },
  tip: {
    type: String,
    default: '',
  },
})

const emit = defineEmits(['update:modelValue', 'remove'])

const updateField = (key, value) => {
  const newItem = { ...props.modelValue, [key]: value }
  emit('update:modelValue', newItem)
}
</script>

<style lang="scss" scoped>
@import './rules.scss';
</style>
